// threadUnread.js

import { toMillis } from 'channels/utils/channelTime';

const getReplyCount = (message) => {
  const count = Number(message?.replyCount);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

/**
 * Whether the current user is eligible to see thread unread state.
 *
 * @param {object} options - Eligibility options.
 * @param {object} options.rootMessage - Thread root message.
 * @param {string} options.currentUserKey - Active user key.
 * @returns {boolean}
 */
export const isThreadUnreadEligible = ({ rootMessage, currentUserKey } = {}) => {
  const cleanUserKey = String(currentUserKey || '').trim();
  if (!cleanUserKey || !rootMessage?.key) return false;

  if (String(rootMessage?.userKey || '').trim() === cleanUserKey) {
    return true;
  }

  const participantKeys = Array.isArray(rootMessage?.threadParticipantKeys)
    ? rootMessage.threadParticipantKeys
    : [];

  return participantKeys.includes(cleanUserKey);
};

/**
 * Whether a thread has unread replies for the current user.
 *
 * @param {object} options - Unread options.
 * @param {object} options.rootMessage - Thread root message.
 * @param {object} options.readReceipt - Channel read receipt row.
 * @param {string} options.currentUserKey - Active user key.
 * @returns {boolean}
 */
export const isThreadUnread = ({ rootMessage, readReceipt, currentUserKey } = {}) => {
  if (!getReplyCount(rootMessage)) return false;
  if (!isThreadUnreadEligible({ rootMessage, currentUserKey })) return false;

  const lastReplyAtMs = toMillis(rootMessage?.lastReplyAt);
  if (!lastReplyAtMs) return false;

  if (String(rootMessage?.lastReplyByKey || '').trim() === String(currentUserKey || '').trim()) {
    return false;
  }

  const threadReads = readReceipt?.threadReads && typeof readReceipt.threadReads === 'object'
    ? readReceipt.threadReads
    : {};

  const lastThreadReadMs = toMillis(threadReads[rootMessage.key]);
  return lastReplyAtMs > lastThreadReadMs;
};
